import { render, staticRenderFns } from "./jointPreferencesSkuInfo.vue?vue&type=template&id=3b1dc9fe&scoped=true&"
import script from "./jointPreferencesSkuInfo.vue?vue&type=script&lang=js&"
export * from "./jointPreferencesSkuInfo.vue?vue&type=script&lang=js&"
import style0 from "./jointPreferencesSkuInfo.vue?vue&type=style&index=0&id=3b1dc9fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1dc9fe",
  null
  
)

export default component.exports